import { buildUrl } from "../util/integration"

const HTTP_METHOD = Object.freeze({
    get: "GET",
});

const REQUEST_HEADER = Object.freeze({
    privacyPolicy: Object.freeze({
        Accept:
            "application/pdf, application/octet-stream",
    }),
});

function requireUserId(
    userId,
) {
    if (
        userId === null
        || userId === undefined
        || userId === ""
    ) {
        throw new TypeError(
            "userId darf nicht leer sein.",
        );
    }

    return encodeURIComponent(
        String(userId),
    );
}

export function fetchOperatorImprintAPI() {
    return fetch(
        buildUrl(
            "imprint/operator",
        ),
        {
            method:
                HTTP_METHOD.get,
        },
    );
}

export function fetchOperatorPrivacyPolicyAPI() {
    return fetch(
        buildUrl(
            "imprint/operator/privacy_policy",
        ),
        {
            method:
                HTTP_METHOD.get,

            headers:
                REQUEST_HEADER
                    .privacyPolicy,
        },
    );
}

export function fetchOperatorTermsAPI() {
    return fetch(
        buildUrl(
            "imprint/operator/terms",
        ),
        {
            method:
                HTTP_METHOD.get,

            headers:
                REQUEST_HEADER
                    .privacyPolicy,
        },
    );
}



export function fetchSellerImprintAPI(
    userId,
) {
    const encodedUserId =
        requireUserId(
            userId,
        );

    return fetch(
        buildUrl(
            `imprint/user/${encodedUserId}`,
        ),
        {
            method:
                HTTP_METHOD.get,
        },
    );
}